import { combineReducers } from 'redux'
import board from './board'
import robot from './robot'
import status from './status'
import goals from './goals'
import log from './log'
import highscore from './highscore'
import newChallenge from './newChallenge'
import nextChallenge from './nextChallenge'

const rootReducer = combineReducers({
  board,
  robot,
  status,
  goals,
  log,
  highscore,
  newChallenge,
  nextChallenge
})

export default rootReducer



// WEBPACK FOOTER //
// ./reducers/index.js